import { render, staticRenderFns } from "./Managed-companies-views.vue?vue&type=template&id=1d1b5826"
import script from "./Managed-companies-views.vue?vue&type=script&lang=js"
export * from "./Managed-companies-views.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports